<div
  class="col-auto pl-3 pr-0 pl-md-0"
  *ngIf="!disabledIfAll || selected.length"
>
  <div class="dropdown" ngbDropdown container="body" placement="bottom-left">
    <button
      class="btn btn-sm btn-white dropdown-toggle"
      type="button"
      id="bulkActionDropdown"
      ngbDropdownToggle
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      [disabled]="disabledIfAll && !selected.length"
    >
      <!-- {{
        (selected.length
          ? 'list-bulk-actions.selected'
          : 'list-bulk-actions.all-items'
        ) | translate
      }} -->
      <!-- ({{ selected && selected.length ? selected.length : totalItems }}) -->
      <i class="fa fa-spinner-third fa-spin" *ngIf="isLoading"></i>
      [{{ selected && selected.length ? selected.length : totalItems }}]
    </button>
    <div
      class="dropdown-menu dropdown-menu-right"
      aria-labelledby="bulkActionDropdown"
      ngbDropdownMenu
    >
      <ng-content></ng-content>
      <div class="dropdown-divider" *ngIf="selected && selected.length"></div>
      <a
        class="dropdown-item"
        href=""
        (click)="onUnselectAll(); (false)"
        *ngIf="selected.length"
      >
        <i class="mr-1 fe fe-x fe-fw"></i>
        {{ 'Clear selection' | translate }}</a
      >
    </div>
  </div>
</div>
